import { get } from './client.js';

export const getInsights = (orgId) => get(`/orgs/${orgId}/insights`);
